export default function SplitEditorLayout({ isOpen, left, right, panelWidth = '380px' }) {
  const openLayoutClass = panelWidth === '420px'
    ? 'xl:grid-cols-[minmax(0,1fr)_420px]'
    : 'xl:grid-cols-[minmax(0,1fr)_380px]'

  const panelWidthClass = panelWidth === '420px' ? 'xl:w-[420px]' : 'xl:w-[380px]'

  return (
    <div className="relative">
      <div
        className={`grid grid-cols-1 gap-4 transition-all duration-300 ${isOpen ? openLayoutClass : 'xl:grid-cols-1'}`}
      >
        <div className={`min-w-0 transition-all duration-300 ${isOpen ? 'xl:pr-2' : ''}`}>
          {left}
        </div>

        <div
          className={`min-w-0 transition-all duration-300 overflow-hidden ${isOpen ? `max-xl:block ${panelWidthClass} xl:opacity-100` : 'hidden xl:block xl:w-0 xl:opacity-0'}`}
        >
          {isOpen ? right : null}
        </div>
      </div>
    </div>
  )
}
